
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/sneeuwgeschiedenis-sneeuwhistorie",
      function () {
        return require("private-next-pages/[region]/[resort]/sneeuwgeschiedenis-sneeuwhistorie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/sneeuwgeschiedenis-sneeuwhistorie"])
      });
    }
  